var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Delete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v2H16v-2a4 4 0 014-4h10v-4h16v4h10a4 4 0 014 4zm-39 6h34v33a6 6 0 01-6 6H27a6 6 0 01-6-6V25zm24 33h4V31h-4v27zm-9 0h4V31h-4v27zm-9 0h4V31h-4v27z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Delete.2a82747d.svg";
export { SvgJ2Delete as ReactComponent };